module.exports = "<toaster-container [toasterconfig]=\"toasterconfig\"></toaster-container>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Fed/src/app/core/logger/logger.component.html
// module id = ../../../../../src/app/core/logger/logger.component.html
// module chunks = main